import { environment } from "./../../../../environments/environment";
import { Component, ElementRef, OnInit } from "@angular/core";
import { AdminService } from "@app/views/private/admin/services/admin.service";
import { OpenService } from "@app-services/open.service";
import { Contact, LayoutVars } from "@app/store/session/session.store";
import { MarketPlacePersonalizationUtils } from "@app-components/layouts/shopkeeper-layout/marketplace-personalization";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  year = new Date().getFullYear();

  personalization: boolean = false;
  layoutVars: LayoutVars;
  contacts: Contact[] = [];
  address: string;
  linkFacebook;
  linkInstagram;
  linkLinkedIn;
  linkX;
  linkAboutUs;
  linkTerms;
  linkContact;

  constructor(
    private openService: OpenService,
    private elRef : ElementRef
  ) {}

  ngOnInit(): void {
    this.openService.getLayoutVars().subscribe( r => {
      if(r && r.alternativeDomain){
        this.personalization = true;
        this.layoutVars = r;
        if(this.layoutVars.footerContacts){
          this.contacts = this.layoutVars.footerContacts.filter(c =>
            c.type === 'PHONE_NUMBER' || c.type === 'EMAIL' || c.type === 'WHATSAPP')
            .map(c => {
              if (c.type === 'EMAIL') {
                return {
                  ...c,
                  href: 'mailto:' + c.contact
                };
              } else {
                const contact = c.contact.replace(/\D/g, '');
                return {
                  ...c,
                  href: c.type === 'PHONE_NUMBER' ? 'tel:' + contact : 'https://wa.me/' + contact
                };
              }
            });

          this.address = this.layoutVars.footerContacts.find(c => c.type === 'ADDRESS')?.contact;
          this.linkFacebook = this.layoutVars.footerContacts.find(c => c.type === 'FACEBOOK')?.contact;
          this.linkInstagram = this.layoutVars.footerContacts.find(c => c.type === 'INSTAGRAM')?.contact;
          this.linkLinkedIn = this.layoutVars.footerContacts.find(c => c.type === 'LINKEDIN')?.contact;
          this.linkX = this.layoutVars.footerContacts.find(c => c.type === 'X')?.contact;
          this.linkAboutUs = this.layoutVars.linkAboutUs;
          this.linkTerms = this.layoutVars.personalizedTermsUrl;
          this.linkContact = this.layoutVars.linkContact;

        }
        MarketPlacePersonalizationUtils.initCssVars(this.elRef, this.layoutVars);
      }
    });
  }

  getUrl(url) {
    return environment.urlBlog + url;
  }

  getLoginUrl(url) {
    return environment.url + url;
  }
}
